import { gql } from "@apollo/client";

export const FORCE_APPROVE_INVOICE = gql`
  mutation forceApproveInvoice($input: ForceApproveInvoiceInput!) {
    invoice {
      forceApproveInvoice(input: $input) {
        success
      }
    }
  }
`;
